// import React, { useMemo, useState, useEffect, useLayoutEffect, useRef } from 'react';
// import Link from 'next/link';
// import Image from 'next/image';
// import { createPortal } from 'react-dom';
// import { getShippingInfo } from '~/utilities/shippingInfo';
// import { calculateBasePrice } from '~/utilities/basePriceCalculator';

// const EuroSup = () => (
//   <sup
//     className="rw-pd-top__euro"
//     style={{ fontSize: '0.6em', fontWeight: 500, marginLeft: '1px' }}
//   >
//     €
//   </sup>
// );

// const STAR_ON = '#f5a623';
// const STAR_OFF = '#d5d8dd';

// const REVIEWS_SECTION_ID = 'pd-section-9';
// const REVIEWS_SCROLL_OFFSET = 75;

// const STAR_PATH =
//   'M24.8676481,9.0008973 C24.7082329,8.54565507 24.2825324,8.23189792 23.7931772,8.20897226 L16.1009423,8.20897226 L13.658963,0.793674161 C13.485078,-0.0267985214 12.9965414,-0.0267985214 12.4623931,0.00174912135 L12.4623931,0.00174912135 C11.9394964,-0.00194214302 11.4747239,0.328465149 11.3146628,0.81767189 L8.87268352,8.23296999 L1.20486846,8.23296999 C0.689809989,8.22949161 0.230279943,8.55030885 0.0640800798,9.0294023 C-0.102119784,9.50849575 0.0623083246,10.0383495 0.472274662,10.3447701 L6.69932193,14.9763317 L4.25734261,22.4396253 C4.08483744,22.9295881 4.25922828,23.4727606 4.68662933,23.7767181 C5.11403038,24.0806756 5.69357086,24.0736812 6.11324689,23.7595003 L12.6333317,18.9599546 L19.1778362,23.7595003 C19.381674,23.9119158 19.6299002,23.9960311 19.8860103,23.9994776 C20.2758842,24.0048539 20.6439728,23.8232161 20.8724402,23.5127115 C21.1009077,23.202207 21.1610972,22.8017824 21.0337405,22.4396253 L18.5917612,14.9763317 L24.6967095,10.3207724 C25.0258477,9.95783882 25.0937839,9.43328063 24.8676481,9.0008973 Z';

// const Star = ({ size, fillPercent }) => (
//   <span
//     className="rw-pd-top__rating-star"
//     style={{
//       position: 'relative',
//       display: 'inline-block',
//       width: `${size}px`,
//       height: `${size}px`,
//       marginRight: '1px',
//     }}
//   >
//     <svg
//       className="rw-pd-top__rating-star-icon rw-pd-top__rating-star-icon--off"
//       xmlns="http://www.w3.org/2000/svg"
//       width={size}
//       height={size}
//       viewBox="0 0 25 25"
//       aria-hidden="true"
//       focusable="false"
//       style={{ display: 'block' }}
//     >
//       <path d={STAR_PATH} fill={STAR_OFF} />
//     </svg>

//     {fillPercent > 0 && (
//       <span
//         className="rw-pd-top__rating-star-fill"
//         style={{
//           position: 'absolute',
//           top: 0,
//           left: 0,
//           width: `${fillPercent}%`,
//           height: '100%',
//           overflow: 'hidden',
//         }}
//       >
//         <svg
//           className="rw-pd-top__rating-star-icon rw-pd-top__rating-star-icon--on"
//           xmlns="http://www.w3.org/2000/svg"
//           width={size}
//           height={size}
//           viewBox="0 0 25 25"
//           aria-hidden="true"
//           focusable="false"
//           style={{ display: 'block', maxWidth: 'none' }}
//         >
//           <path d={STAR_PATH} fill={STAR_ON} />
//         </svg>
//       </span>
//     )}
//   </span>
// );

// const getStarValue = (rating) => {
//   const r = Math.min(5, Math.max(0, Math.round((Number(rating) || 0) * 100) / 100));
//   const whole = Math.floor(r);
//   const fraction = Math.round((r - whole) * 100) / 100;

//   if (fraction === 0) return whole;
//   if (fraction < 0.5) return whole + 0.5;
//   return whole + 1;
// };

// const RatingStars = ({ rating = 0, size = 16 }) => {
//   const value = getStarValue(rating);

//   return (
//     <div
//       className="rw-pd-top__rating-stars"
//       style={{ display: 'flex', alignItems: 'center' }}
//     >
//       {[0, 1, 2, 3, 4].map((i) => (
//         <Star
//           key={i}
//           size={size}
//           fillPercent={Math.max(0, Math.min(1, value - i)) * 100}
//         />
//       ))}
//     </div>
//   );
// };

// const discountBadgeStyle = {
//   borderRadius: '3px',
//   background: 'rgb(253, 236, 236)',
//   border: '1px solid rgb(250, 207, 207)',
//   display: 'inline-flex',
//   alignItems: 'center',
//   padding: '2px 6px',
//   width: 'fit-content',
//   fontSize: '12px',
//   lineHeight: '14px',
//   fontWeight: 700,
//   color: 'rgb(191, 0, 0)',
//   boxSizing: 'border-box',
//   letterSpacing: '0.3px',
//   whiteSpace: 'nowrap',
//   flexShrink: 0,
// };

// const ModuleDetailTopInformation = ({ product, selectedVariant, onReviewClick, titleHref }) => {
//   const productAttrs = product?.attributes || {};
//   const variantAttrs = selectedVariant?.attributes || {};
//   const attrs = selectedVariant && Object.keys(selectedVariant).length ? variantAttrs : productAttrs;

//   const {
//     title,
//     sub_title,
//     product_brands,
//     product_typs,
//     baseprice_product_amount,
//     baseprice_product_unit,
//     baseprice_reference_amount,
//     baseprice_reference_unit,
//     energy_efficiency_label,
//     energy_efficiency_datasheet,
//   } = attrs;

//   const [isSlideInVisible, setSlideInVisible] = useState(false);
//   const [isSlideInAnimated, setSlideInAnimated] = useState(false);
//   const [isSizeTableVisible, setSizeTableVisible] = useState(false);
//   const [isSizeTableAnimated, setSizeTableAnimated] = useState(false);
//   const [showBestPriceTooltip, setShowBestPriceTooltip] = useState(false);
//   const [tooltipPos, setTooltipPos] = useState(null);
//   const [tooltipStyle, setTooltipStyle] = useState(null);
//   const tooltipBoxRef = useRef(null);
//   const bestPriceTooltipRef = useRef(null);

//   const updateTooltipPosition = () => {
//     if (bestPriceTooltipRef.current) {
//       const rect = bestPriceTooltipRef.current.getBoundingClientRect();

//       setTooltipPos({
//         top: rect.top,
//         left: rect.left + rect.width / 2,
//       });
//     }
//   };

//   const ratingAverage = Number(attrs.review) || 0;
//   const ratingCount = Number(attrs.reviewCount) || 0;
//   const reviewLabel = `${ratingCount} Bewertung${ratingCount === 1 ? '' : 'en'}`;
//   const ratingAverageText = ratingAverage.toLocaleString('de-DE', {
//     minimumFractionDigits: 1,
//     maximumFractionDigits: 1,
//   });

//   const handleScrollToReviews = () => {
//     if (typeof window === 'undefined') return;

//     window.dispatchEvent(new CustomEvent('rw:goto-reviews'));

//     const el = document.getElementById(REVIEWS_SECTION_ID);
//     if (!el) return;

//     const top = el.getBoundingClientRect().top + window.pageYOffset - REVIEWS_SCROLL_OFFSET;
//     window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
//   };

//   const productBrandName = useMemo(() => {
//     return (
//       product_brands?.data?.attributes?.title ||
//       productAttrs?.product_brands?.data?.attributes?.title ||
//       ''
//     );
//   }, [product_brands, productAttrs]);

//   const productBrandLogoUrl = useMemo(() => {
//     const apiPath = process.env.NEXT_PUBLIC_FRONTEND_URL;

//     const manufacturer =
//       product_brands?.data?.attributes?.manufacturer_url ||
//       productAttrs?.product_brands?.data?.attributes?.manufacturer_url;

//     return manufacturer ? `${apiPath}/${manufacturer}` : null;
//   }, [product_brands, productAttrs]);

//   const brandLink = useMemo(() => {
//     const slug =
//       product_brands?.data?.attributes?.slug ||
//       productAttrs?.product_brands?.data?.attributes?.slug ||
//       '';

//     return `/brand/${slug}`;
//   }, [product_brands, productAttrs]);

//   const productPriceValue = useMemo(() => {
//     if (variantAttrs?.price != null) return variantAttrs.price;
//     if (productAttrs?.price != null) return productAttrs.price;
//     return null;
//   }, [variantAttrs, productAttrs]);

//   const lowest30d = useMemo(() => {
//     if (variantAttrs?.lowestPrice30d != null) return variantAttrs.lowestPrice30d;
//     if (productAttrs?.lowestPrice30d != null) return productAttrs.lowestPrice30d;
//     return null;
//   }, [variantAttrs, productAttrs]);

//   const currentPrice = useMemo(() => {
//     return productPriceValue != null ? Number(productPriceValue) : null;
//   }, [productPriceValue]);

//   const showReduction = useMemo(() => {
//     return lowest30d !== null && currentPrice !== null && Number(lowest30d) > currentPrice;
//   }, [lowest30d, currentPrice]);

//   const discountPercent = useMemo(() => {
//     if (!showReduction) return null;
//     return (((Number(lowest30d) - currentPrice) / Number(lowest30d)) * 100).toFixed(0);
//   }, [showReduction, lowest30d, currentPrice]);

//   const productPrice = useMemo(() => {
//     if (currentPrice == null) return null;

//     if (showReduction) {
//       return (
//         <h4 className="ps-product__price sale">
//           <span
//             className="ps-product__price--current"
//             style={{ marginRight: '5px' }}
//           >
//             {currentPrice.toLocaleString('de-DE', {
//               minimumFractionDigits: 2,
//             })}
//             <EuroSup />
//           </span>

//           <del
//             className="rw-pd-top__price--old"
//             style={{
//               fontSize: '0.6em',
//               fontWeight: 500,
//               color: 'rgb(122, 117, 117)',
//             }}
//           >
//             {Number(lowest30d).toLocaleString('de-DE', {
//               minimumFractionDigits: 2,
//             })}
//             <EuroSup />
//           </del>
//         </h4>
//       );
//     }

//     return (
//       <h4 className="ps-product__price">
//         {currentPrice.toLocaleString('de-DE', {
//           minimumFractionDigits: 2,
//         })}
//         <EuroSup />
//       </h4>
//     );
//   }, [currentPrice, lowest30d, showReduction]);

//   const taxRate = useMemo(() => {
//     if (variantAttrs?.taxes?.data?.attributes?.tax_rate != null) {
//       return variantAttrs.taxes.data.attributes.tax_rate;
//     }

//     if (productAttrs?.taxes?.data?.attributes?.tax_rate != null) {
//       return productAttrs.taxes.data.attributes.tax_rate;
//     }

//     return 0;
//   }, [variantAttrs, productAttrs]);

//   const taxAndShippingInfo = useMemo(() => {
//     return taxRate ? `inkl. ${taxRate}% MwSt.` : 'inkl. MwSt.';
//   }, [taxRate]);

//   const rawShippingType =
//     variantAttrs?.shippings?.data?.attributes?.shipping_type ||
//     productAttrs?.shippings?.data?.attributes?.shipping_type ||
//     'Kostenloser Versand';

//   const shippingType = useMemo(() => {
//     const normalized = String(rawShippingType).trim().toLowerCase();

//     if (normalized === 'versand mit dhl paket') {
//       return 'Versand mit DHL Paket';
//     }

//     if (normalized === 'lieferung durch spedition') {
//       return 'Lieferung durch Spedition';
//     }

//     if (['digitaler versand', 'esd versand', 'esd'].includes(normalized)) {
//       return 'ESD Versand';
//     }

//     return rawShippingType;
//   }, [rawShippingType]);

//   const shippingLinkText = useMemo(() => {
//     if (shippingType === 'Versand mit DHL Paket') {
//       return ' zzgl. Versand';
//     }

//     if (shippingType === 'Lieferung durch Spedition') {
//       return ' zzgl. Spedition';
//     }

//     if (shippingType === 'ESD Versand') {
//       return ' digitaler Versand';
//     }

//     return '';
//   }, [shippingType]);

//   const shouldShowShippingSlider = useMemo(
//     () =>
//       [
//         'Versand mit DHL Paket',
//         'Lieferung durch Spedition',
//         'ESD Versand',
//       ].includes(shippingType),
//     [shippingType]
//   );

//   const shippingInfoText = useMemo(
//     () => getShippingInfo(shippingType),
//     [shippingType]
//   );

//   const basePricePerUnit = useMemo(
//     () =>
//       calculateBasePrice(
//         productPriceValue,
//         baseprice_product_amount,
//         baseprice_product_unit,
//         baseprice_reference_amount,
//         baseprice_reference_unit
//       ),
//     [
//       productPriceValue,
//       baseprice_product_amount,
//       baseprice_product_unit,
//       baseprice_reference_amount,
//       baseprice_reference_unit,
//     ]
//   );

//   const energyImagePath =
//     variantAttrs?.energy_efficiencies?.data?.attributes?.energy_efficiency_image ||
//     productAttrs?.energy_efficiencies?.data?.attributes?.energy_efficiency_image;

//   const energyEfficiencyImage = energyImagePath
//     ? `${process.env.NEXT_PUBLIC_FRONTEND_URL}${energyImagePath}`
//     : null;

//   const energyEfficiencyLabelUrl = energy_efficiency_label
//     ? `${process.env.NEXT_PUBLIC_FRONTEND_URL}/${energy_efficiency_label}`
//     : null;

//   const energyEfficiencyDatasheetUrl = energy_efficiency_datasheet
//     ? `${process.env.NEXT_PUBLIC_FRONTEND_URL}/${energy_efficiency_datasheet}`
//     : null;

//   const handleImageClick = () => {
//     if (energyEfficiencyLabelUrl) {
//       window.open(energyEfficiencyLabelUrl, '_blank');
//     }
//   };

//   const handleDatasheetClick = () => {
//     if (energyEfficiencyDatasheetUrl) {
//       window.open(energyEfficiencyDatasheetUrl, '_blank');
//     }
//   };

//   const toggleSlideIn = () => {
//     if (isSlideInVisible) {
//       setSlideInAnimated(false);
//       setTimeout(() => setSlideInVisible(false), 500);
//     } else {
//       setSlideInVisible(true);

//       requestAnimationFrame(() => {
//         requestAnimationFrame(() => {
//           setSlideInAnimated(true);
//         });
//       });
//     }
//   };

//   const toggleSizeTable = () => {
//     if (isSizeTableVisible) {
//       setSizeTableAnimated(false);
//       setTimeout(() => setSizeTableVisible(false), 500);
//     } else {
//       setSizeTableVisible(true);

//       requestAnimationFrame(() => {
//         requestAnimationFrame(() => {
//           setSizeTableAnimated(true);
//         });
//       });
//     }
//   };

//   const handleBestPriceTooltipClick = (e) => {
//     e.stopPropagation();
//     updateTooltipPosition();
//     setShowBestPriceTooltip(true);
//   };

//   const handleBestPriceMouseEnter = () => {
//     updateTooltipPosition();
//     setShowBestPriceTooltip(true);
//   };

//   useEffect(() => {
//     if (!showBestPriceTooltip) return undefined;

//     updateTooltipPosition();

//     window.addEventListener('scroll', updateTooltipPosition, true);
//     window.addEventListener('resize', updateTooltipPosition);

//     return () => {
//       window.removeEventListener('scroll', updateTooltipPosition, true);
//       window.removeEventListener('resize', updateTooltipPosition);
//     };
//   }, [showBestPriceTooltip]);

//   useLayoutEffect(() => {
//     if (!showBestPriceTooltip || !tooltipPos || !tooltipBoxRef.current) {
//       setTooltipStyle(null);
//       return;
//     }

//     const margin = 12;
//     const rect = tooltipBoxRef.current.getBoundingClientRect();

//     let boxLeft = tooltipPos.left - rect.width / 2;
//     let boxRight = boxLeft + rect.width;
//     let shift = 0;

//     if (boxLeft < margin) {
//       shift = margin - boxLeft;
//     } else if (boxRight > window.innerWidth - margin) {
//       shift = window.innerWidth - margin - boxRight;
//     }

//     setTooltipStyle({
//       left: tooltipPos.left + shift,
//       arrowLeft: `calc(50% - ${shift}px)`,
//     });
//   }, [showBestPriceTooltip, tooltipPos]);

//   useEffect(() => {
//     if (!showBestPriceTooltip) return undefined;

//     const handleOutsideInteraction = (e) => {
//       if (
//         bestPriceTooltipRef.current &&
//         !bestPriceTooltipRef.current.contains(e.target)
//       ) {
//         setShowBestPriceTooltip(false);
//       }
//     };

//     document.addEventListener('click', handleOutsideInteraction);
//     document.addEventListener('touchstart', handleOutsideInteraction);

//     return () => {
//       document.removeEventListener('click', handleOutsideInteraction);
//       document.removeEventListener('touchstart', handleOutsideInteraction);
//     };
//   }, [showBestPriceTooltip]);

//   useEffect(() => {
//     document.body.style.overflow =
//       isSlideInVisible || isSizeTableVisible ? 'hidden' : '';

//     const handleEscape = (e) => {
//       if (e.key === 'Escape') {
//         if (isSlideInVisible) toggleSlideIn();
//         if (isSizeTableVisible) toggleSizeTable();
//       }
//     };

//     document.addEventListener('keydown', handleEscape);

//     return () => {
//       document.body.style.overflow = '';
//       document.removeEventListener('keydown', handleEscape);
//     };
//   }, [
//     isSlideInVisible,
//     isSlideInAnimated,
//     isSizeTableVisible,
//     isSizeTableAnimated,
//   ]);

//   const productTypeData =
//     product_typs?.data?.attributes ||
//     productAttrs?.product_typs?.data?.attributes ||
//     {};

//   const productTypeTitle = productTypeData.title || '';
//   const productTypeSlug = productTypeData.slug || '';
//   const productTitle = title || productAttrs?.title || 'Unbenanntes Produkt';

//   const sellerName = useMemo(() => {
//     return (
//       variantAttrs?.merchant?.data?.attributes?.sellerName ||
//       productAttrs?.merchant?.data?.attributes?.sellerName ||
//       null
//     );
//   }, [variantAttrs, productAttrs]);

//   const ringSizes = [
//     ['15,1', '48', '4,5'],
//     ['15,6', '49', '5'],
//     ['15,9', '50', '5,3'],
//     ['16,2', '51', '5,7'],
//     ['16,6', '52', '6'],
//     ['16,9', '53', '6,4'],
//     ['17,2', '54', '6,8'],
//     ['17,5', '55', '7'],
//     ['17,8', '56', '7,6'],
//     ['18,1', '57', '8'],
//     ['18,5', '58', '8,4'],
//     ['18,8', '59', '8,7'],
//     ['19,1', '60', '9,1'],
//     ['19,4', '61', '9,5'],
//     ['20', '62', '9,9'],
//     ['20,4', '63', '10,3'],
//     ['20,7', '64', '10,7'],
//     ['21', '65', '11'],
//   ];

//   return (
//     <header
//       className="rw-pd-top__header"
//       style={{ position: 'relative', zIndex: 1 }}
//     >
//       <div className="ps-product__meta">
//         {productBrandLogoUrl ? (
//           <Link href={brandLink} className="rw-pd-top__brand-link">
//             <img
//               className="rw-pd-top__brand-logo"
//               src={productBrandLogoUrl}
//               alt={productBrandName}
//               width={100}
//             />
//           </Link>
//         ) : (
//           <Link href={brandLink} className="rw-pd-top__brand-link">
//             {productBrandName}
//           </Link>
//         )}
//       </div>

//       <h1 className="rw-pd-top__title">
//         {titleHref ? (
//           <Link
//             href={titleHref}
//             className="rw-pd-top__title-link"
//             style={{ color: 'inherit', textDecoration: 'none' }}
//           >
//             {productTitle}
//           </Link>
//         ) : (
//           productTitle
//         )}
//       </h1>

//       {sub_title && (
//         <div className="rw-pd-top__subtitle" style={{ color: '#888' }}>
//           {sub_title}
//         </div>
//       )}

//       {productTypeTitle && (
//         <div
//           className="rw-pd-top__type-row"
//           style={{
//             marginBottom: '0px',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'space-between',
//             flexWrap: 'wrap',
//           }}
//         >
//           <Link
//             href={`/producttyp/${encodeURIComponent(productTypeSlug)}`}
//             className="producttyp-link rw-pd-top__type-link"
//             style={{ cursor: 'pointer', color: '#0066cc' }}
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//             {productTypeTitle}
//           </Link>

//           {productTypeSlug === 'ringe' && (
//             <button
//               type="button"
//               className="rw-pd-top__size-table-button"
//               onClick={toggleSizeTable}
//               style={{
//                 background: 'none',
//                 border: 'none',
//                 padding: '0 10px 0 0',
//                 cursor: 'pointer',
//                 display: 'flex',
//                 alignItems: 'flex-end',
//                 gap: '3px',
//                 color: 'currentColor',
//               }}
//               aria-label="Größentabelle öffnen"
//             >
//               <svg
//                 className="rw-pd-top__size-table-icon"
//                 xmlns="http://www.w3.org/2000/svg"
//                 width="21"
//                 height="21"
//                 viewBox="0 0 32 32"
//                 fill="currentColor"
//                 style={{ position: 'relative', top: '2px' }}
//               >
//                 <path
//                   d="M27.628 9.53a.625.625 0 0 0-.625.625c0 2.697-2.557 4.856-6.515 5.86v-5.139c.006-.069.017-.137.017-.207 0-2.45-3.184-4.297-7.411-4.297-5.241.04-9.347 2.325-9.347 5.203v7.748c0 2.922 3.464 5.316 8.315 6.06.02.002.037.012.058.012l.011-.002c.998.15 2.05.235 3.147.235.217 0 .426-.012.639-.017.028.004.054.017.083.017.038 0 .071-.015.108-.022 7.189-.224 12.145-3.322 12.145-7.702v-7.748a.625.625 0 0 0-.625-.625Zm-16.975 3.652c.927.619 2.284 1.013 3.842 1.013 1.972 0 3.662-.504 4.744-1.314v3.22c0 .063.019.12.036.178-1.233.224-2.57.35-3.996.35-1.657 0-3.233-.208-4.635-.568l.011-2.879Zm2.446-5.56c3.682 0 6.156 1.576 6.156 3.047 0 1.099-1.913 2.276-4.76 2.276-2.199 0-3.843-.898-3.843-1.701a.625.625 0 0 0-1.25 0c0 .064.025.124.032.187-.008.04-.024.076-.024.118l-.015 4.135c-2.636-.926-4.397-2.437-4.397-4.11 0-2.109 3.712-3.919 8.102-3.953Zm13.904 10.281c0 1.659-.967 3.115-2.63 4.225v-3.087a.625.625 0 0 0-1.25 0v3.787c-.778.373-1.656.685-2.618.93v-3.396a.625.625 0 0 0-1.25 0v3.667c-.831.15-1.707.257-2.63.308V20.79a.625.625 0 0 0-1.25 0v3.583l-.097.002c-.872 0-1.718-.062-2.533-.169v-3.65a.625.625 0 0 0-1.25 0v3.446a15.287 15.287 0 0 1-2.618-.763v-3.772a.625.625 0 0 0-1.25 0v3.181c-1.623-.897-2.63-2.065-2.63-3.328v-4.847c1.89 2.038 5.74 3.403 10.281 3.403 5.376 0 9.699-1.661 11.725-4.245V17.9Z"
//                   fill="currentColor"
//                 />
//               </svg>

//               <p
//                 className="rw-pd-top__size-table-label"
//                 style={{
//                   fontSize: '12px',
//                   lineHeight: '18px',
//                   margin: '0px',
//                   letterSpacing: '0.4px',
//                 }}
//               >
//                 Größentabelle
//               </p>
//             </button>
//           )}
//         </div>
//       )}

//       <div
//         className="bv_rating_summary_buttons_container rw-pd-top__rating"
//         style={{
//           marginBottom: '10px',
//           display: 'flex',
//           alignItems: 'center',
//           gap: '12px',
//           padding: '4px 0',
//           flexWrap: 'wrap',
//         }}
//       >
//         <div
//           className="rw-pd-top__rating-summary"
//           style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
//         >
//           <button
//             type="button"
//             className="rw-pd-top__rating-button"
//             onClick={handleScrollToReviews}
//             aria-label={`${ratingAverageText} von 5 Sternen, ${reviewLabel} – zu den Bewertungen springen`}
//             style={{
//               background: 'none',
//               border: 'none',
//               padding: 0,
//               display: 'flex',
//               alignItems: 'center',
//               gap: '8px',
//               cursor: 'pointer',
//             }}
//           >
//             <RatingStars rating={ratingAverage} size={16} />

//             <span
//               className="rw-pd-top__rating-count"
//               style={{
//                 color: '#666',
//                 fontSize: '14px',
//                 textDecoration: 'underline',
//                 textUnderlineOffset: '2px',
//               }}
//             >
//               ({ratingCount})
//             </span>
//           </button>
//         </div>

//         <button
//           type="button"
//           className="rw-pd-top__review-button"
//           onClick={onReviewClick}
//           style={{
//             background: 'none',
//             border: 'none',
//             padding: '4px 8px',
//             cursor: 'pointer',
//             color: '#666',
//             fontSize: '14px',
//             textDecoration: 'underline',
//             textUnderlineOffset: '2px',
//             lineHeight: '1.4',
//           }}
//           aria-label="Jetzt Produkt bewerten"
//         >
//           Produkt bewerten
//         </button>
//       </div>

//       <div
//         className="rw-pd-top__price-row"
//         style={{
//           display: 'flex',
//           justifyContent: 'space-between',
//           alignItems: 'center',
//         }}
//       >
//         <div
//           className="rw-pd-top__price-col"
//           style={{ flex: 1, minWidth: 0 }}
//         >
//           <div
//             className="ps-product__price-wrapper"
//             style={{
//               display: 'flex',
//               alignItems: 'center',
//               flexWrap: 'wrap',
//               gap: '10px',
//             }}
//           >
//             {productPrice}

//             {discountPercent !== null && (
//               <div
//                 data-testid="product-tag"
//                 className="ps-product__discount-badge"
//                 style={discountBadgeStyle}
//               >
//                 -{discountPercent}%
//               </div>
//             )}
//           </div>

//           <div
//             className="ps-product__tax-info"
//             style={{ marginTop: '0.5rem' }}
//           >
//             <span
//               className="rw-pd-top__tax-text"
//               style={{
//                 fontSize: '12px',
//                 lineHeight: '18px',
//                 color: 'rgb(122, 117, 117)',
//               }}
//             >
//               {taxAndShippingInfo}
//             </span>

//             {shouldShowShippingSlider && (
//               <span
//                 className="ps-product__shipping-link"
//                 style={{
//                   fontSize: '12px',
//                   lineHeight: '18px',
//                   color: '#06c',
//                   cursor: 'pointer',
//                   textDecoration: 'none',
//                 }}
//                 onClick={toggleSlideIn}
//               >
//                 {shippingLinkText}
//               </span>
//             )}
//           </div>

//           {basePricePerUnit && (
//             <div
//               className="ps-product__base-price"
//               style={{ marginTop: '2px' }}
//             >
//               <span
//                 className="rw-pd-top__base-price-text"
//                 style={{
//                   fontSize: '12px',
//                   lineHeight: '18px',
//                   color: 'rgb(122, 117, 117)',
//                 }}
//               >
//                 {basePricePerUnit}
//                 <EuroSup /> / 1 {baseprice_reference_unit}
//               </span>
//             </div>
//           )}

//           {showReduction && (
//             <div
//               className="ps-product__best-price-info"
//               style={{
//                 marginTop: '0.4rem',
//                 display: 'flex',
//                 flexDirection: 'column',
//                 gap: '2px',
//               }}
//             >
//               <div
//                 className="rw-pd-top__best-price-row"
//                 style={{
//                   display: 'flex',
//                   flexWrap: 'wrap',
//                   alignItems: 'center',
//                   gap: '4px',
//                 }}
//               >
//                 <span
//                   className="rw-pd-top__best-price-label"
//                   style={{
//                     fontSize: '12px',
//                     lineHeight: 1.6,
//                     color: 'rgb(122, 117, 117)',
//                   }}
//                 >
//                   30 Tage Bestpreis:
//                 </span>

//                 <span
//                   className="rw-pd-top__best-price-value"
//                   style={{
//                     fontSize: '12px',
//                     lineHeight: 1.6,
//                     fontWeight: 500,
//                     color: 'rgb(122, 117, 117)',
//                     whiteSpace: 'nowrap',
//                   }}
//                 >
//                   {Number(lowest30d).toLocaleString('de-DE', {
//                     minimumFractionDigits: 2,
//                   })}
//                   <EuroSup />
//                 </span>

//                 <button
//                   ref={bestPriceTooltipRef}
//                   type="button"
//                   className="rw-pd-top__best-price-button"
//                   aria-label="Bestpreisinformationen"
//                   onMouseEnter={handleBestPriceMouseEnter}
//                   onMouseLeave={() => setShowBestPriceTooltip(false)}
//                   onClick={handleBestPriceTooltipClick}
//                   style={{
//                     position: 'relative',
//                     cursor: 'help',
//                     border: 'none',
//                     background: 'transparent',
//                     padding: '2px',
//                     margin: 0,
//                     display: 'inline-flex',
//                     alignItems: 'center',
//                   }}
//                 >
//                   <svg
//                     className="rw-pd-top__best-price-icon"
//                     xmlns="http://www.w3.org/2000/svg"
//                     width="16"
//                     height="16"
//                     viewBox="0 0 32 32"
//                     fill="#7A7575"
//                     style={{ display: 'block' }}
//                   >
//                     <g>
//                       <g>
//                         <path
//                           d="M16.196 17.808a.639.639 0 0 1-.639-.639v-.857a1.919 1.919 0 0 1 1.278-1.808 1.917 1.917 0 1 0-2.557-1.809.639.639 0 1 1-1.278 0 3.2 3.2 0 1 1 4.261 3.013.641.641 0 0 0-.426.6v.858a.639.639 0 0 1-.636.642Z"
//                           fill="#7A7575"
//                         />
//                         <circle
//                           cx="16.196"
//                           cy="21.641"
//                           r="0.959"
//                           fill="#7A7575"
//                         />
//                       </g>

//                       <path
//                         d="M16 27.6A11.6 11.6 0 1 1 27.6 16 11.613 11.613 0 0 1 16 27.6Zm0-22A10.4 10.4 0 1 0 26.4 16 10.412 10.412 0 0 0 16 5.6Z"
//                         fill="#7A7575"
//                       />
//                     </g>
//                   </svg>
//                 </button>

//                 {showBestPriceTooltip &&
//                   tooltipPos &&
//                   createPortal(
//                     <div
//                       ref={tooltipBoxRef}
//                       className="rw-pd-top__best-price-tooltip"
//                       style={{
//                         position: 'fixed',
//                         top: tooltipPos.top - 8,
//                         left: (tooltipStyle ?? tooltipPos).left,
//                         transform: 'translate(-50%, -100%)',
//                         backgroundColor: '#333',
//                         color: '#fff',
//                         padding: '8px 12px',
//                         borderRadius: '4px',
//                         fontSize: '12px',
//                         lineHeight: '1.4',
//                         whiteSpace: 'normal',
//                         maxWidth: 'min(260px, calc(100vw - 24px))',
//                         width: 'max-content',
//                         zIndex: 10000,
//                         boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
//                         pointerEvents: 'none',
//                         visibility: tooltipStyle ? 'visible' : 'hidden',
//                       }}
//                     >
//                       Günstigster Preis der letzten 30 Tage vor der letzten
//                       Preisanpassung

//                       <div
//                         className="rw-pd-top__best-price-tooltip-arrow"
//                         style={{
//                           position: 'absolute',
//                           top: '100%',
//                           left: tooltipStyle
//                             ? tooltipStyle.arrowLeft
//                             : '50%',
//                           transform: 'translateX(-50%)',
//                           width: 0,
//                           height: 0,
//                           borderLeft: '5px solid transparent',
//                           borderRight: '5px solid transparent',
//                           borderTop: '5px solid #333',
//                         }}
//                       />
//                     </div>,
//                     document.body
//                   )}
//               </div>
//             </div>
//           )}

//           {sellerName && (
//             <div
//               className="rw-pd-top__seller"
//               style={{
//                 marginTop: showReduction ? '2px' : '0.4rem',
//               }}
//             >
//               <span
//                 className="rw-pd-top__seller-text"
//                 style={{
//                   fontSize: '12px',
//                   lineHeight: 1.6,
//                   color: 'rgb(122, 117, 117)',
//                 }}
//               >
//                 Versand durch {sellerName}
//               </span>
//             </div>
//           )}
//         </div>

//         {energyEfficiencyImage && (
//           <div
//             className="rw-pd-top__energy"
//             style={{
//               textAlign: 'center',
//               display: 'flex',
//               flexDirection: 'column',
//               alignItems: 'center',
//               flexShrink: 0,
//               marginLeft: '10px',
//             }}
//           >
//             <Image
//               className="rw-pd-top__energy-image"
//               src={energyEfficiencyImage}
//               alt="Energy Label"
//               width={60}
//               height={60}
//               onClick={handleImageClick}
//               style={{ cursor: 'pointer' }}
//             />

//             {energyEfficiencyDatasheetUrl && (
//               <div
//                 className="rw-pd-top__energy-datasheet"
//                 onClick={handleDatasheetClick}
//                 style={{
//                   cursor: 'pointer',
//                   color: '#0073e6',
//                   marginTop: '5px',
//                   fontWeight: 'bold',
//                 }}
//               >
//                 Produktdatenblatt
//               </div>
//             )}
//           </div>
//         )}
//       </div>

//       {isSlideInVisible &&
//         createPortal(
//           <>
//             <div
//               className={`rw-slidein-overlay ${isSlideInAnimated ? 'open' : ''}`}
//               onClick={toggleSlideIn}
//             />

//             <div className={`rw-slidein ${isSlideInAnimated ? 'open' : ''}`}>
//               <div className="rw-slidein__header">
//                 <h3 className="rw-slidein__title">Versandinformationen</h3>

//                 <button
//                   type="button"
//                   className="rw-slidein__close"
//                   onClick={toggleSlideIn}
//                   aria-label="Versandinformationen schließen"
//                 >
//                   ×
//                 </button>
//               </div>

//               <div className="rw-slidein__body">{shippingInfoText}</div>
//             </div>
//           </>,
//           document.body
//         )}

//       {isSizeTableVisible &&
//         createPortal(
//           <>
//             <div
//               className={`rw-slidein-overlay ${isSizeTableAnimated ? 'open' : ''}`}
//               onClick={toggleSizeTable}
//             />

//             <div className={`rw-slidein ${isSizeTableAnimated ? 'open' : ''}`}>
//               <div className="rw-slidein__header">
//                 <h3 className="rw-slidein__title">Ringgrößentabelle</h3>

//                 <button
//                   type="button"
//                   className="rw-slidein__close"
//                   onClick={toggleSizeTable}
//                   aria-label="Ringgrößentabelle schließen"
//                 >
//                   ×
//                 </button>
//               </div>

//               <div className="rw-slidein__body" style={{ touchAction: 'pan-y' }}>
//                 <p
//                   className="rw-pd-top__size-table-intro"
//                   style={{
//                     fontSize: '14px',
//                     lineHeight: '21px',
//                     margin: '0 0 20px 0',
//                     letterSpacing: '0.4px',
//                   }}
//                 >
//                   Hier finden Sie eine nützliche Größentabelle, die Ihnen hilft,
//                   die ermittelten Maße in die passende Ringgröße umzuwandeln.
//                 </p>

//                 <div
//                   className="rw-pd-top__size-table-wrapper"
//                   style={{
//                     position: 'relative',
//                     width: '100%',
//                     maxWidth: '100%',
//                     overflowX: 'hidden',
//                     overflowY: 'visible',
//                     scrollbarWidth: 'none',
//                     WebkitOverflowScrolling: 'touch',
//                     touchAction: 'pan-y',
//                     boxSizing: 'border-box',
//                   }}
//                 >
//                   <table
//                     className="rw-pd-top__size-table"
//                     style={{
//                       borderCollapse: 'collapse',
//                       borderSpacing: 0,
//                       width: '100%',
//                       maxWidth: '100%',
//                       tableLayout: 'fixed',
//                       letterSpacing: '0.4px',
//                     }}
//                   >
//                     <colgroup>
//                       <col style={{ width: '36%' }} />
//                       <col style={{ width: '32%' }} />
//                       <col style={{ width: '32%' }} />
//                     </colgroup>

//                     <thead className="rw-pd-top__size-table-head">
//                       <tr className="rw-pd-top__size-table-row">
//                         {[
//                           'Durchmesser (mm)',
//                           'Ringgröße (EU)',
//                           'Ringgröße (US)',
//                         ].map((header, index) => (
//                           <th
//                             key={header}
//                             className="rw-pd-top__size-table-th"
//                             style={{
//                               background: '#e9ecef',
//                               padding: '12px 8px',
//                               borderTop: '1.11111px solid #ccc',
//                               borderRight:
//                                 index < 2
//                                   ? '1.11111px solid #ccc'
//                                   : undefined,
//                               textAlign: 'left',
//                               verticalAlign: 'top',
//                               fontSize: '13px',
//                               lineHeight: '18px',
//                               fontWeight: 900,
//                               overflowWrap: 'break-word',
//                               wordBreak: 'normal',
//                             }}
//                           >
//                             {header}
//                           </th>
//                         ))}
//                       </tr>
//                     </thead>

//                     <tbody className="rw-pd-top__size-table-body">
//                       {ringSizes.map((row, rowIndex) => (
//                         <tr
//                           key={rowIndex}
//                           className="rw-pd-top__size-table-row"
//                         >
//                           {row.map((cell, cellIndex) => (
//                             <td
//                               key={`${rowIndex}-${cellIndex}`}
//                               className="rw-pd-top__size-table-td"
//                               style={{
//                                 padding: '11px 8px',
//                                 borderTop: '1.11111px solid #ccc',
//                                 borderRight:
//                                   cellIndex < 2
//                                     ? '1.11111px solid #ccc'
//                                     : undefined,
//                                 verticalAlign: 'top',
//                                 fontSize: '13px',
//                                 lineHeight: '18px',
//                                 overflowWrap: 'break-word',
//                                 wordBreak: 'normal',
//                               }}
//                             >
//                               {cell}
//                             </td>
//                           ))}
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//             </div>
//           </>,
//           document.body
//         )}
//     </header>
//   );
// };

// export default ModuleDetailTopInformation;


// src/components/elements/detail/modules/ModuleDetailTopInformation.jsx
import React, { useMemo, useState, useEffect, useLayoutEffect, useRef } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { createPortal } from 'react-dom';
import { getShippingInfo } from '~/utilities/shippingInfo';
import { calculateBasePrice } from '~/utilities/basePriceCalculator';

const EuroSup = () => (
  <sup
    className="rw-pd-top__euro"
    style={{ fontSize: '0.6em', fontWeight: 500, marginLeft: '1px' }}
  >
    €
  </sup>
);

const STAR_ON = '#f5a623';
const STAR_OFF = '#d5d8dd';

const REVIEWS_SECTION_ID = 'pd-section-9';
const REVIEWS_SCROLL_OFFSET = 75;

const STAR_PATH =
  'M24.8676481,9.0008973 C24.7082329,8.54565507 24.2825324,8.23189792 23.7931772,8.20897226 L16.1009423,8.20897226 L13.658963,0.793674161 C13.485078,-0.0267985214 12.9965414,-0.0267985214 12.4623931,0.00174912135 L12.4623931,0.00174912135 C11.9394964,-0.00194214302 11.4747239,0.328465149 11.3146628,0.81767189 L8.87268352,8.23296999 L1.20486846,8.23296999 C0.689809989,8.22949161 0.230279943,8.55030885 0.0640800798,9.0294023 C-0.102119784,9.50849575 0.0623083246,10.0383495 0.472274662,10.3447701 L6.69932193,14.9763317 L4.25734261,22.4396253 C4.08483744,22.9295881 4.25922828,23.4727606 4.68662933,23.7767181 C5.11403038,24.0806756 5.69357086,24.0736812 6.11324689,23.7595003 L12.6333317,18.9599546 L19.1778362,23.7595003 C19.381674,23.9119158 19.6299002,23.9960311 19.8860103,23.9994776 C20.2758842,24.0048539 20.6439728,23.8232161 20.8724402,23.5127115 C21.1009077,23.202207 21.1610972,22.8017824 21.0337405,22.4396253 L18.5917612,14.9763317 L24.6967095,10.3207724 C25.0258477,9.95783882 25.0937839,9.43328063 24.8676481,9.0008973 Z';

const Star = ({ size, fillPercent }) => (
  <span
    className="rw-pd-top__rating-star"
    style={{
      position: 'relative',
      display: 'inline-block',
      width: `${size}px`,
      height: `${size}px`,
      marginRight: '1px',
    }}
  >
    <svg
      className="rw-pd-top__rating-star-icon rw-pd-top__rating-star-icon--off"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 25 25"
      aria-hidden="true"
      focusable="false"
      style={{ display: 'block' }}
    >
      <path d={STAR_PATH} fill={STAR_OFF} />
    </svg>

    {fillPercent > 0 && (
      <span
        className="rw-pd-top__rating-star-fill"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: `${fillPercent}%`,
          height: '100%',
          overflow: 'hidden',
        }}
      >
        <svg
          className="rw-pd-top__rating-star-icon rw-pd-top__rating-star-icon--on"
          xmlns="http://www.w3.org/2000/svg"
          width={size}
          height={size}
          viewBox="0 0 25 25"
          aria-hidden="true"
          focusable="false"
          style={{ display: 'block', maxWidth: 'none' }}
        >
          <path d={STAR_PATH} fill={STAR_ON} />
        </svg>
      </span>
    )}
  </span>
);

const getStarValue = (rating) => {
  const r = Math.min(5, Math.max(0, Math.round((Number(rating) || 0) * 100) / 100));
  const whole = Math.floor(r);
  const fraction = Math.round((r - whole) * 100) / 100;

  if (fraction === 0) return whole;
  if (fraction < 0.5) return whole + 0.5;
  return whole + 1;
};

const RatingStars = ({ rating = 0, size = 16 }) => {
  const value = getStarValue(rating);

  return (
    <div
      className="rw-pd-top__rating-stars"
      style={{ display: 'flex', alignItems: 'center' }}
    >
      {[0, 1, 2, 3, 4].map((i) => (
        <Star
          key={i}
          size={size}
          fillPercent={Math.max(0, Math.min(1, value - i)) * 100}
        />
      ))}
    </div>
  );
};

const discountBadgeStyle = {
  borderRadius: '3px',
  background: 'rgb(253, 236, 236)',
  border: '1px solid rgb(250, 207, 207)',
  display: 'inline-flex',
  alignItems: 'center',
  padding: '2px 6px',
  width: 'fit-content',
  fontSize: '12px',
  lineHeight: '14px',
  fontWeight: 700,
  color: 'rgb(191, 0, 0)',
  boxSizing: 'border-box',
  letterSpacing: '0.3px',
  whiteSpace: 'nowrap',
  flexShrink: 0,
};

const MOBILE_HIDE_SUBTITLE_CSS =
  '@media (max-width: 767px) { .rw-pd-top__subtitle { display: none !important; } }';

const ModuleDetailTopInformation = ({ product, selectedVariant, onReviewClick, titleHref }) => {
  const productAttrs = product?.attributes || {};
  const variantAttrs = selectedVariant?.attributes || {};
  const attrs = selectedVariant && Object.keys(selectedVariant).length ? variantAttrs : productAttrs;

  const {
    title,
    sub_title,
    product_brands,
    product_typs,
    baseprice_product_amount,
    baseprice_product_unit,
    baseprice_reference_amount,
    baseprice_reference_unit,
    energy_efficiency_label,
    energy_efficiency_datasheet,
  } = attrs;

  const [isSlideInVisible, setSlideInVisible] = useState(false);
  const [isSlideInAnimated, setSlideInAnimated] = useState(false);
  const [isSizeTableVisible, setSizeTableVisible] = useState(false);
  const [isSizeTableAnimated, setSizeTableAnimated] = useState(false);
  const [showBestPriceTooltip, setShowBestPriceTooltip] = useState(false);
  const [tooltipPos, setTooltipPos] = useState(null);
  const [tooltipStyle, setTooltipStyle] = useState(null);
  const tooltipBoxRef = useRef(null);
  const bestPriceTooltipRef = useRef(null);

  const updateTooltipPosition = () => {
    if (bestPriceTooltipRef.current) {
      const rect = bestPriceTooltipRef.current.getBoundingClientRect();

      setTooltipPos({
        top: rect.top,
        left: rect.left + rect.width / 2,
      });
    }
  };

  const ratingAverage = Number(attrs.review) || 0;
  const ratingCount = Number(attrs.reviewCount) || 0;
  const reviewLabel = `${ratingCount} Bewertung${ratingCount === 1 ? '' : 'en'}`;
  const ratingAverageText = ratingAverage.toLocaleString('de-DE', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  });

  const handleScrollToReviews = () => {
    if (typeof window === 'undefined') return;

    window.dispatchEvent(new CustomEvent('rw:goto-reviews'));

    const el = document.getElementById(REVIEWS_SECTION_ID);
    if (!el) return;

    const top = el.getBoundingClientRect().top + window.pageYOffset - REVIEWS_SCROLL_OFFSET;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  };

  const productBrandName = useMemo(() => {
    return (
      product_brands?.data?.attributes?.title ||
      productAttrs?.product_brands?.data?.attributes?.title ||
      ''
    );
  }, [product_brands, productAttrs]);

  const productBrandLogoUrl = useMemo(() => {
    const apiPath = process.env.NEXT_PUBLIC_FRONTEND_URL;

    const manufacturer =
      product_brands?.data?.attributes?.manufacturer_url ||
      productAttrs?.product_brands?.data?.attributes?.manufacturer_url;

    return manufacturer ? `${apiPath}/${manufacturer}` : null;
  }, [product_brands, productAttrs]);

  const brandLink = useMemo(() => {
    const slug =
      product_brands?.data?.attributes?.slug ||
      productAttrs?.product_brands?.data?.attributes?.slug ||
      '';

    return `/brand/${slug}`;
  }, [product_brands, productAttrs]);

  const productPriceValue = useMemo(() => {
    if (variantAttrs?.price != null) return variantAttrs.price;
    if (productAttrs?.price != null) return productAttrs.price;
    return null;
  }, [variantAttrs, productAttrs]);

  const lowest30d = useMemo(() => {
    if (variantAttrs?.lowestPrice30d != null) return variantAttrs.lowestPrice30d;
    if (productAttrs?.lowestPrice30d != null) return productAttrs.lowestPrice30d;
    return null;
  }, [variantAttrs, productAttrs]);

  const currentPrice = useMemo(() => {
    return productPriceValue != null ? Number(productPriceValue) : null;
  }, [productPriceValue]);

  const showReduction = useMemo(() => {
    return lowest30d !== null && currentPrice !== null && Number(lowest30d) > currentPrice;
  }, [lowest30d, currentPrice]);

  const discountPercent = useMemo(() => {
    if (!showReduction) return null;
    return (((Number(lowest30d) - currentPrice) / Number(lowest30d)) * 100).toFixed(0);
  }, [showReduction, lowest30d, currentPrice]);

  const productPrice = useMemo(() => {
    if (currentPrice == null) return null;

    if (showReduction) {
      return (
        <h4 className="ps-product__price sale">
          <span
            className="ps-product__price--current"
            style={{ marginRight: '5px' }}
          >
            {currentPrice.toLocaleString('de-DE', {
              minimumFractionDigits: 2,
            })}
            <EuroSup />
          </span>

          <del
            className="rw-pd-top__price--old"
            style={{
              fontSize: '0.6em',
              fontWeight: 500,
              color: 'rgb(122, 117, 117)',
            }}
          >
            {Number(lowest30d).toLocaleString('de-DE', {
              minimumFractionDigits: 2,
            })}
            <EuroSup />
          </del>
        </h4>
      );
    }

    return (
      <h4 className="ps-product__price">
        {currentPrice.toLocaleString('de-DE', {
          minimumFractionDigits: 2,
        })}
        <EuroSup />
      </h4>
    );
  }, [currentPrice, lowest30d, showReduction]);

  const taxRate = useMemo(() => {
    if (variantAttrs?.taxes?.data?.attributes?.tax_rate != null) {
      return variantAttrs.taxes.data.attributes.tax_rate;
    }

    if (productAttrs?.taxes?.data?.attributes?.tax_rate != null) {
      return productAttrs.taxes.data.attributes.tax_rate;
    }

    return 0;
  }, [variantAttrs, productAttrs]);

  const taxAndShippingInfo = useMemo(() => {
    return taxRate ? `inkl. ${taxRate}% MwSt.` : 'inkl. MwSt.';
  }, [taxRate]);

  const rawShippingType =
    variantAttrs?.shippings?.data?.attributes?.shipping_type ||
    productAttrs?.shippings?.data?.attributes?.shipping_type ||
    'Kostenloser Versand';

  const shippingType = useMemo(() => {
    const normalized = String(rawShippingType).trim().toLowerCase();

    if (normalized === 'versand mit dhl paket') {
      return 'Versand mit DHL Paket';
    }

    if (normalized === 'lieferung durch spedition') {
      return 'Lieferung durch Spedition';
    }

    if (['digitaler versand', 'esd versand', 'esd'].includes(normalized)) {
      return 'ESD Versand';
    }

    return rawShippingType;
  }, [rawShippingType]);

  const shippingLinkText = useMemo(() => {
    if (shippingType === 'Versand mit DHL Paket') {
      return ' zzgl. Versand';
    }

    if (shippingType === 'Lieferung durch Spedition') {
      return ' zzgl. Spedition';
    }

    if (shippingType === 'ESD Versand') {
      return ' digitaler Versand';
    }

    return '';
  }, [shippingType]);

  const shouldShowShippingSlider = useMemo(
    () =>
      [
        'Versand mit DHL Paket',
        'Lieferung durch Spedition',
        'ESD Versand',
      ].includes(shippingType),
    [shippingType]
  );

  const shippingInfoText = useMemo(
    () => getShippingInfo(shippingType),
    [shippingType]
  );

  const basePricePerUnit = useMemo(
    () =>
      calculateBasePrice(
        productPriceValue,
        baseprice_product_amount,
        baseprice_product_unit,
        baseprice_reference_amount,
        baseprice_reference_unit
      ),
    [
      productPriceValue,
      baseprice_product_amount,
      baseprice_product_unit,
      baseprice_reference_amount,
      baseprice_reference_unit,
    ]
  );

  const energyImagePath =
    variantAttrs?.energy_efficiencies?.data?.attributes?.energy_efficiency_image ||
    productAttrs?.energy_efficiencies?.data?.attributes?.energy_efficiency_image;

  const energyEfficiencyImage = energyImagePath
    ? `${process.env.NEXT_PUBLIC_FRONTEND_URL}${energyImagePath}`
    : null;

  const energyEfficiencyLabelUrl = energy_efficiency_label
    ? `${process.env.NEXT_PUBLIC_FRONTEND_URL}/${energy_efficiency_label}`
    : null;

  const energyEfficiencyDatasheetUrl = energy_efficiency_datasheet
    ? `${process.env.NEXT_PUBLIC_FRONTEND_URL}/${energy_efficiency_datasheet}`
    : null;

  const handleImageClick = () => {
    if (energyEfficiencyLabelUrl) {
      window.open(energyEfficiencyLabelUrl, '_blank');
    }
  };

  const handleDatasheetClick = () => {
    if (energyEfficiencyDatasheetUrl) {
      window.open(energyEfficiencyDatasheetUrl, '_blank');
    }
  };

  const toggleSlideIn = () => {
    if (isSlideInVisible) {
      setSlideInAnimated(false);
      setTimeout(() => setSlideInVisible(false), 500);
    } else {
      setSlideInVisible(true);

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setSlideInAnimated(true);
        });
      });
    }
  };

  const toggleSizeTable = () => {
    if (isSizeTableVisible) {
      setSizeTableAnimated(false);
      setTimeout(() => setSizeTableVisible(false), 500);
    } else {
      setSizeTableVisible(true);

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          setSizeTableAnimated(true);
        });
      });
    }
  };

  const handleBestPriceTooltipClick = (e) => {
    e.stopPropagation();
    updateTooltipPosition();
    setShowBestPriceTooltip(true);
  };

  const handleBestPriceMouseEnter = () => {
    updateTooltipPosition();
    setShowBestPriceTooltip(true);
  };

  useEffect(() => {
    if (!showBestPriceTooltip) return undefined;

    updateTooltipPosition();

    window.addEventListener('scroll', updateTooltipPosition, true);
    window.addEventListener('resize', updateTooltipPosition);

    return () => {
      window.removeEventListener('scroll', updateTooltipPosition, true);
      window.removeEventListener('resize', updateTooltipPosition);
    };
  }, [showBestPriceTooltip]);

  useLayoutEffect(() => {
    if (!showBestPriceTooltip || !tooltipPos || !tooltipBoxRef.current) {
      setTooltipStyle(null);
      return;
    }

    const margin = 12;
    const rect = tooltipBoxRef.current.getBoundingClientRect();

    let boxLeft = tooltipPos.left - rect.width / 2;
    let boxRight = boxLeft + rect.width;
    let shift = 0;

    if (boxLeft < margin) {
      shift = margin - boxLeft;
    } else if (boxRight > window.innerWidth - margin) {
      shift = window.innerWidth - margin - boxRight;
    }

    setTooltipStyle({
      left: tooltipPos.left + shift,
      arrowLeft: `calc(50% - ${shift}px)`,
    });
  }, [showBestPriceTooltip, tooltipPos]);

  useEffect(() => {
    if (!showBestPriceTooltip) return undefined;

    const handleOutsideInteraction = (e) => {
      if (
        bestPriceTooltipRef.current &&
        !bestPriceTooltipRef.current.contains(e.target)
      ) {
        setShowBestPriceTooltip(false);
      }
    };

    document.addEventListener('click', handleOutsideInteraction);
    document.addEventListener('touchstart', handleOutsideInteraction);

    return () => {
      document.removeEventListener('click', handleOutsideInteraction);
      document.removeEventListener('touchstart', handleOutsideInteraction);
    };
  }, [showBestPriceTooltip]);

  useEffect(() => {
    document.body.style.overflow =
      isSlideInVisible || isSizeTableVisible ? 'hidden' : '';

    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        if (isSlideInVisible) toggleSlideIn();
        if (isSizeTableVisible) toggleSizeTable();
      }
    };

    document.addEventListener('keydown', handleEscape);

    return () => {
      document.body.style.overflow = '';
      document.removeEventListener('keydown', handleEscape);
    };
  }, [
    isSlideInVisible,
    isSlideInAnimated,
    isSizeTableVisible,
    isSizeTableAnimated,
  ]);

  const productTypeData =
    product_typs?.data?.attributes ||
    productAttrs?.product_typs?.data?.attributes ||
    {};

  const productTypeTitle = productTypeData.title || '';
  const productTypeSlug = productTypeData.slug || '';
  const productTitle = title || productAttrs?.title || 'Unbenanntes Produkt';

  const sellerName = useMemo(() => {
    return (
      variantAttrs?.merchant?.data?.attributes?.sellerName ||
      productAttrs?.merchant?.data?.attributes?.sellerName ||
      null
    );
  }, [variantAttrs, productAttrs]);

  const ringSizes = [
    ['15,1', '48', '4,5'],
    ['15,6', '49', '5'],
    ['15,9', '50', '5,3'],
    ['16,2', '51', '5,7'],
    ['16,6', '52', '6'],
    ['16,9', '53', '6,4'],
    ['17,2', '54', '6,8'],
    ['17,5', '55', '7'],
    ['17,8', '56', '7,6'],
    ['18,1', '57', '8'],
    ['18,5', '58', '8,4'],
    ['18,8', '59', '8,7'],
    ['19,1', '60', '9,1'],
    ['19,4', '61', '9,5'],
    ['20', '62', '9,9'],
    ['20,4', '63', '10,3'],
    ['20,7', '64', '10,7'],
    ['21', '65', '11'],
  ];

  return (
    <header
      className="rw-pd-top__header"
      style={{ position: 'relative', zIndex: 1 }}
    >
      <style>{MOBILE_HIDE_SUBTITLE_CSS}</style>

      <div className="ps-product__meta">
        {productBrandLogoUrl ? (
          <Link href={brandLink} className="rw-pd-top__brand-link">
            <img
              className="rw-pd-top__brand-logo"
              src={productBrandLogoUrl}
              alt={productBrandName}
              width={100}
            />
          </Link>
        ) : (
          <Link href={brandLink} className="rw-pd-top__brand-link">
            {productBrandName}
          </Link>
        )}
      </div>

      <h1 className="rw-pd-top__title">
        {titleHref ? (
          <Link
            href={titleHref}
            className="rw-pd-top__title-link"
            style={{ color: 'inherit', textDecoration: 'none' }}
          >
            {productTitle}
          </Link>
        ) : (
          productTitle
        )}
      </h1>

      {sub_title && (
        <div className="rw-pd-top__subtitle" style={{ color: '#888' }}>
          {sub_title}
        </div>
      )}

      {productTypeTitle && (
        <div
          className="rw-pd-top__type-row"
          style={{
            marginBottom: '0px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
          }}
        >
          <Link
            href={`/producttyp/${encodeURIComponent(productTypeSlug)}`}
            className="producttyp-link rw-pd-top__type-link"
            style={{ cursor: 'pointer', color: '#0066cc' }}
            target="_blank"
            rel="noopener noreferrer"
          >
            {productTypeTitle}
          </Link>

          {productTypeSlug === 'ringe' && (
            <button
              type="button"
              className="rw-pd-top__size-table-button"
              onClick={toggleSizeTable}
              style={{
                background: 'none',
                border: 'none',
                padding: '0 10px 0 0',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'flex-end',
                gap: '3px',
                color: 'currentColor',
              }}
              aria-label="Größentabelle öffnen"
            >
              <svg
                className="rw-pd-top__size-table-icon"
                xmlns="http://www.w3.org/2000/svg"
                width="21"
                height="21"
                viewBox="0 0 32 32"
                fill="currentColor"
                style={{ position: 'relative', top: '2px' }}
              >
                <path
                  d="M27.628 9.53a.625.625 0 0 0-.625.625c0 2.697-2.557 4.856-6.515 5.86v-5.139c.006-.069.017-.137.017-.207 0-2.45-3.184-4.297-7.411-4.297-5.241.04-9.347 2.325-9.347 5.203v7.748c0 2.922 3.464 5.316 8.315 6.06.02.002.037.012.058.012l.011-.002c.998.15 2.05.235 3.147.235.217 0 .426-.012.639-.017.028.004.054.017.083.017.038 0 .071-.015.108-.022 7.189-.224 12.145-3.322 12.145-7.702v-7.748a.625.625 0 0 0-.625-.625Zm-16.975 3.652c.927.619 2.284 1.013 3.842 1.013 1.972 0 3.662-.504 4.744-1.314v3.22c0 .063.019.12.036.178-1.233.224-2.57.35-3.996.35-1.657 0-3.233-.208-4.635-.568l.011-2.879Zm2.446-5.56c3.682 0 6.156 1.576 6.156 3.047 0 1.099-1.913 2.276-4.76 2.276-2.199 0-3.843-.898-3.843-1.701a.625.625 0 0 0-1.25 0c0 .064.025.124.032.187-.008.04-.024.076-.024.118l-.015 4.135c-2.636-.926-4.397-2.437-4.397-4.11 0-2.109 3.712-3.919 8.102-3.953Zm13.904 10.281c0 1.659-.967 3.115-2.63 4.225v-3.087a.625.625 0 0 0-1.25 0v3.787c-.778.373-1.656.685-2.618.93v-3.396a.625.625 0 0 0-1.25 0v3.667c-.831.15-1.707.257-2.63.308V20.79a.625.625 0 0 0-1.25 0v3.583l-.097.002c-.872 0-1.718-.062-2.533-.169v-3.65a.625.625 0 0 0-1.25 0v3.446a15.287 15.287 0 0 1-2.618-.763v-3.772a.625.625 0 0 0-1.25 0v3.181c-1.623-.897-2.63-2.065-2.63-3.328v-4.847c1.89 2.038 5.74 3.403 10.281 3.403 5.376 0 9.699-1.661 11.725-4.245V17.9Z"
                  fill="currentColor"
                />
              </svg>

              <p
                className="rw-pd-top__size-table-label"
                style={{
                  fontSize: '12px',
                  lineHeight: '18px',
                  margin: '0px',
                  letterSpacing: '0.4px',
                }}
              >
                Größentabelle
              </p>
            </button>
          )}
        </div>
      )}

      <div
        className="bv_rating_summary_buttons_container rw-pd-top__rating"
        style={{
          marginBottom: '10px',
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          padding: '4px 0',
          flexWrap: 'wrap',
        }}
      >
        <div
          className="rw-pd-top__rating-summary"
          style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
        >
          <button
            type="button"
            className="rw-pd-top__rating-button"
            onClick={handleScrollToReviews}
            aria-label={`${ratingAverageText} von 5 Sternen, ${reviewLabel} – zu den Bewertungen springen`}
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              cursor: 'pointer',
            }}
          >
            <RatingStars rating={ratingAverage} size={16} />

            <span
              className="rw-pd-top__rating-count"
              style={{
                color: '#666',
                fontSize: '14px',
                textDecoration: 'underline',
                textUnderlineOffset: '2px',
              }}
            >
              ({ratingCount})
            </span>
          </button>
        </div>

        <button
          type="button"
          className="rw-pd-top__review-button"
          onClick={onReviewClick}
          style={{
            background: 'none',
            border: 'none',
            padding: '4px 8px',
            cursor: 'pointer',
            color: '#666',
            fontSize: '14px',
            textDecoration: 'underline',
            textUnderlineOffset: '2px',
            lineHeight: '1.4',
          }}
          aria-label="Jetzt Produkt bewerten"
        >
          Produkt bewerten
        </button>
      </div>

      <div
        className="rw-pd-top__price-row"
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div
          className="rw-pd-top__price-col"
          style={{ flex: 1, minWidth: 0 }}
        >
          <div
            className="ps-product__price-wrapper"
            style={{
              display: 'flex',
              alignItems: 'center',
              flexWrap: 'wrap',
              gap: '10px',
            }}
          >
            {productPrice}

            {discountPercent !== null && (
              <div
                data-testid="product-tag"
                className="ps-product__discount-badge"
                style={discountBadgeStyle}
              >
                -{discountPercent}%
              </div>
            )}
          </div>

          <div
            className="ps-product__tax-info"
            style={{ marginTop: '0.5rem' }}
          >
            <span
              className="rw-pd-top__tax-text"
              style={{
                fontSize: '12px',
                lineHeight: '18px',
                color: 'rgb(122, 117, 117)',
              }}
            >
              {taxAndShippingInfo}
            </span>

            {shouldShowShippingSlider && (
              <span
                className="ps-product__shipping-link"
                style={{
                  fontSize: '12px',
                  lineHeight: '18px',
                  color: '#06c',
                  cursor: 'pointer',
                  textDecoration: 'none',
                }}
                onClick={toggleSlideIn}
              >
                {shippingLinkText}
              </span>
            )}
          </div>

          {basePricePerUnit && (
            <div
              className="ps-product__base-price"
              style={{ marginTop: '2px' }}
            >
              <span
                className="rw-pd-top__base-price-text"
                style={{
                  fontSize: '12px',
                  lineHeight: '18px',
                  color: 'rgb(122, 117, 117)',
                }}
              >
                {basePricePerUnit}
                <EuroSup /> / 1 {baseprice_reference_unit}
              </span>
            </div>
          )}

          {showReduction && (
            <div
              className="ps-product__best-price-info"
              style={{
                marginTop: '0.4rem',
                display: 'flex',
                flexDirection: 'column',
                gap: '2px',
              }}
            >
              <div
                className="rw-pd-top__best-price-row"
                style={{
                  display: 'flex',
                  flexWrap: 'wrap',
                  alignItems: 'center',
                  gap: '4px',
                }}
              >
                <span
                  className="rw-pd-top__best-price-label"
                  style={{
                    fontSize: '12px',
                    lineHeight: 1.6,
                    color: 'rgb(122, 117, 117)',
                  }}
                >
                  30 Tage Bestpreis:
                </span>

                <span
                  className="rw-pd-top__best-price-value"
                  style={{
                    fontSize: '12px',
                    lineHeight: 1.6,
                    fontWeight: 500,
                    color: 'rgb(122, 117, 117)',
                    whiteSpace: 'nowrap',
                  }}
                >
                  {Number(lowest30d).toLocaleString('de-DE', {
                    minimumFractionDigits: 2,
                  })}
                  <EuroSup />
                </span>

                <button
                  ref={bestPriceTooltipRef}
                  type="button"
                  className="rw-pd-top__best-price-button"
                  aria-label="Bestpreisinformationen"
                  onMouseEnter={handleBestPriceMouseEnter}
                  onMouseLeave={() => setShowBestPriceTooltip(false)}
                  onClick={handleBestPriceTooltipClick}
                  style={{
                    position: 'relative',
                    cursor: 'help',
                    border: 'none',
                    background: 'transparent',
                    padding: '2px',
                    margin: 0,
                    display: 'inline-flex',
                    alignItems: 'center',
                  }}
                >
                  <svg
                    className="rw-pd-top__best-price-icon"
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 32 32"
                    fill="#7A7575"
                    style={{ display: 'block' }}
                  >
                    <g>
                      <g>
                        <path
                          d="M16.196 17.808a.639.639 0 0 1-.639-.639v-.857a1.919 1.919 0 0 1 1.278-1.808 1.917 1.917 0 1 0-2.557-1.809.639.639 0 1 1-1.278 0 3.2 3.2 0 1 1 4.261 3.013.641.641 0 0 0-.426.6v.858a.639.639 0 0 1-.636.642Z"
                          fill="#7A7575"
                        />
                        <circle
                          cx="16.196"
                          cy="21.641"
                          r="0.959"
                          fill="#7A7575"
                        />
                      </g>

                      <path
                        d="M16 27.6A11.6 11.6 0 1 1 27.6 16 11.613 11.613 0 0 1 16 27.6Zm0-22A10.4 10.4 0 1 0 26.4 16 10.412 10.412 0 0 0 16 5.6Z"
                        fill="#7A7575"
                      />
                    </g>
                  </svg>
                </button>

                {showBestPriceTooltip &&
                  tooltipPos &&
                  createPortal(
                    <div
                      ref={tooltipBoxRef}
                      className="rw-pd-top__best-price-tooltip"
                      style={{
                        position: 'fixed',
                        top: tooltipPos.top - 8,
                        left: (tooltipStyle ?? tooltipPos).left,
                        transform: 'translate(-50%, -100%)',
                        backgroundColor: '#333',
                        color: '#fff',
                        padding: '8px 12px',
                        borderRadius: '4px',
                        fontSize: '12px',
                        lineHeight: '1.4',
                        whiteSpace: 'normal',
                        maxWidth: 'min(260px, calc(100vw - 24px))',
                        width: 'max-content',
                        zIndex: 10000,
                        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                        pointerEvents: 'none',
                        visibility: tooltipStyle ? 'visible' : 'hidden',
                      }}
                    >
                      Günstigster Preis der letzten 30 Tage vor der letzten
                      Preisanpassung

                      <div
                        className="rw-pd-top__best-price-tooltip-arrow"
                        style={{
                          position: 'absolute',
                          top: '100%',
                          left: tooltipStyle
                            ? tooltipStyle.arrowLeft
                            : '50%',
                          transform: 'translateX(-50%)',
                          width: 0,
                          height: 0,
                          borderLeft: '5px solid transparent',
                          borderRight: '5px solid transparent',
                          borderTop: '5px solid #333',
                        }}
                      />
                    </div>,
                    document.body
                  )}
              </div>
            </div>
          )}

          {sellerName && (
            <div
              className="rw-pd-top__seller"
              style={{
                marginTop: showReduction ? '2px' : '0.4rem',
              }}
            >
              <span
                className="rw-pd-top__seller-text"
                style={{
                  fontSize: '12px',
                  lineHeight: 1.6,
                  color: 'rgb(122, 117, 117)',
                }}
              >
                Versand durch {sellerName}
              </span>
            </div>
          )}
        </div>

        {energyEfficiencyImage && (
          <div
            className="rw-pd-top__energy"
            style={{
              textAlign: 'center',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              flexShrink: 0,
              marginLeft: '10px',
            }}
          >
            <Image
              className="rw-pd-top__energy-image"
              src={energyEfficiencyImage}
              alt="Energy Label"
              width={60}
              height={60}
              onClick={handleImageClick}
              style={{ cursor: 'pointer' }}
            />

            {energyEfficiencyDatasheetUrl && (
              <div
                className="rw-pd-top__energy-datasheet"
                onClick={handleDatasheetClick}
                style={{
                  cursor: 'pointer',
                  color: '#0073e6',
                  marginTop: '5px',
                  fontWeight: 'bold',
                }}
              >
                Produktdatenblatt
              </div>
            )}
          </div>
        )}
      </div>

      {isSlideInVisible &&
        createPortal(
          <>
            <div
              className={`rw-slidein-overlay ${isSlideInAnimated ? 'open' : ''}`}
              onClick={toggleSlideIn}
            />

            <div className={`rw-slidein ${isSlideInAnimated ? 'open' : ''}`}>
              <div className="rw-slidein__header">
                <h3 className="rw-slidein__title">Versandinformationen</h3>

                <button
                  type="button"
                  className="rw-slidein__close"
                  onClick={toggleSlideIn}
                  aria-label="Versandinformationen schließen"
                >
                  ×
                </button>
              </div>

              <div className="rw-slidein__body">{shippingInfoText}</div>
            </div>
          </>,
          document.body
        )}

      {isSizeTableVisible &&
        createPortal(
          <>
            <div
              className={`rw-slidein-overlay ${isSizeTableAnimated ? 'open' : ''}`}
              onClick={toggleSizeTable}
            />

            <div className={`rw-slidein ${isSizeTableAnimated ? 'open' : ''}`}>
              <div className="rw-slidein__header">
                <h3 className="rw-slidein__title">Ringgrößentabelle</h3>

                <button
                  type="button"
                  className="rw-slidein__close"
                  onClick={toggleSizeTable}
                  aria-label="Ringgrößentabelle schließen"
                >
                  ×
                </button>
              </div>

              <div className="rw-slidein__body" style={{ touchAction: 'pan-y' }}>
                <p
                  className="rw-pd-top__size-table-intro"
                  style={{
                    fontSize: '14px',
                    lineHeight: '21px',
                    margin: '0 0 20px 0',
                    letterSpacing: '0.4px',
                  }}
                >
                  Hier finden Sie eine nützliche Größentabelle, die Ihnen hilft,
                  die ermittelten Maße in die passende Ringgröße umzuwandeln.
                </p>

                <div
                  className="rw-pd-top__size-table-wrapper"
                  style={{
                    position: 'relative',
                    width: '100%',
                    maxWidth: '100%',
                    overflowX: 'hidden',
                    overflowY: 'visible',
                    scrollbarWidth: 'none',
                    WebkitOverflowScrolling: 'touch',
                    touchAction: 'pan-y',
                    boxSizing: 'border-box',
                  }}
                >
                  <table
                    className="rw-pd-top__size-table"
                    style={{
                      borderCollapse: 'collapse',
                      borderSpacing: 0,
                      width: '100%',
                      maxWidth: '100%',
                      tableLayout: 'fixed',
                      letterSpacing: '0.4px',
                    }}
                  >
                    <colgroup>
                      <col style={{ width: '36%' }} />
                      <col style={{ width: '32%' }} />
                      <col style={{ width: '32%' }} />
                    </colgroup>

                    <thead className="rw-pd-top__size-table-head">
                      <tr className="rw-pd-top__size-table-row">
                        {[
                          'Durchmesser (mm)',
                          'Ringgröße (EU)',
                          'Ringgröße (US)',
                        ].map((header, index) => (
                          <th
                            key={header}
                            className="rw-pd-top__size-table-th"
                            style={{
                              background: '#e9ecef',
                              padding: '12px 8px',
                              borderTop: '1.11111px solid #ccc',
                              borderRight:
                                index < 2
                                  ? '1.11111px solid #ccc'
                                  : undefined,
                              textAlign: 'left',
                              verticalAlign: 'top',
                              fontSize: '13px',
                              lineHeight: '18px',
                              fontWeight: 900,
                              overflowWrap: 'break-word',
                              wordBreak: 'normal',
                            }}
                          >
                            {header}
                          </th>
                        ))}
                      </tr>
                    </thead>

                    <tbody className="rw-pd-top__size-table-body">
                      {ringSizes.map((row, rowIndex) => (
                        <tr
                          key={rowIndex}
                          className="rw-pd-top__size-table-row"
                        >
                          {row.map((cell, cellIndex) => (
                            <td
                              key={`${rowIndex}-${cellIndex}`}
                              className="rw-pd-top__size-table-td"
                              style={{
                                padding: '11px 8px',
                                borderTop: '1.11111px solid #ccc',
                                borderRight:
                                  cellIndex < 2
                                    ? '1.11111px solid #ccc'
                                    : undefined,
                                verticalAlign: 'top',
                                fontSize: '13px',
                                lineHeight: '18px',
                                overflowWrap: 'break-word',
                                wordBreak: 'normal',
                              }}
                            >
                              {cell}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </>,
          document.body
        )}
    </header>
  );
};

export default ModuleDetailTopInformation;